export default __webpack_public_path__ + "static/media/mc4.91fbe968.png";